<div class="tw-flex tw-flex-row tw-gap-3">
  <div class="tw-relative">
    <button
      class="tw-rounded-full md:tw-w-fit tw-w-14 tw-h-14 tw-bg-white tw-text-main tw-shadow-1 tw-flex tw-justify-center md:tw-px-7 md:tw-py-2 focus:tw-outline-0 hover:tw-bg-gray-50 disabled:tw-opacity-60 disabled:tw-cursor-not-allowed"
      (click)="toggleDropdown()" type="button" cdkOverlayOrigin #trigger="cdkOverlayOrigin"
      [class.!tw-bg-main]="isOpen"
      [class.!tw-text-white]="isOpen"
      [attr.id]="'hotelsSelectorTrigger'"
      [disabled]="disabled"
    >
      <i class="fas fa-hotel tw-self-center tw-text-lg md:tw-text-base"></i>
      <span class="tw-hidden tw-ml-2 md:tw-inline-block tw-text-base tw-font-medium tw-self-center tw-text-main-text" [class.!tw-text-white]="isOpen">
        <ng-container *ngIf="selectedCount === 0">
          {{'shared.filters.hotels.no_selection' | translate}}
        </ng-container>
        
        <ng-container *ngIf="selectedCount > 0 && selectedCount === totalCount">
          {{'shared.filters.hotels.all_selected' | translate}}
        </ng-container>
        
        <ng-container *ngIf="selectedCount > 0 && selectedCount < totalCount">
          <span [title]="hotelsFilter.selectedMultiple.join(', ')" class="tw-cursor-help">
            {{'shared.filters.hotels.selected' | translate}} ({{selectedCount}})
          </span>
        </ng-container>
      </span>
    </button>

    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayOrigin]="trigger"
      [cdkConnectedOverlayOpen]="isOpen"
      [cdkConnectedOverlayHasBackdrop]="true"
      [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
      (backdropClick)="isOpen = false"
    >
      <article class="tw-rounded-lg tw-shadow-xl tw-bg-white tw-mt-1 tw-w-[350px] tw-max-w-[90vw] tw-z-[1000] tw-border-none tw-max-h-[80vh] tw-flex tw-flex-col" [attr.id]="'hotelsSelectorMenu'">
        <div class="tw-p-3 tw-border-b tw-border-gray-200">
          <div class="tw-mb-2 tw-font-medium">{{'shared.filters.hotels.title' | translate}}</div>
          
          <div class="tw-mb-3">
            <input 
              type="text" 
              class="tw-w-full tw-px-2 tw-py-1 tw-text-sm tw-border tw-border-gray-300 tw-rounded focus:tw-outline-none focus:tw-border-blue-500"
              [placeholder]="'shared.filters.hotels.search_placeholder' | translate"
              [(ngModel)]="searchTerm"
              (input)="onSearchChange($event)"
              [disabled]="disabled">
          </div>
          
          <div class="tw-flex tw-gap-2">
            <button 
              type="button"
              class="tw-text-xs tw-px-2 tw-py-1 tw-bg-blue-100 tw-text-blue-700 tw-rounded hover:tw-bg-blue-200 tw-transition-colors disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
              (click)="selectAll()"
              [disabled]="disabled"
              *ngIf="!allSelected">
              {{'shared.filters.hotels.select_all' | translate}}
            </button>
            <button 
              type="button"
              class="tw-text-xs tw-px-2 tw-py-1 tw-bg-gray-100 tw-text-gray-700 tw-rounded hover:tw-bg-gray-200 tw-transition-colors disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
              (click)="deselectAll()"
              [disabled]="disabled"
              *ngIf="allSelected">
              {{'shared.filters.hotels.deselect_all' | translate}}
            </button>
          </div>
        </div>
        
        <div class="tw-flex-1 tw-overflow-y-auto tw-px-3 tw-py-2" [class.tw-pointer-events-none]="disabled" [class.tw-opacity-50]="disabled">
          <div class="tw-flex tw-flex-col tw-w-full">
            <mat-checkbox 
              class="tw-my-1 tw-max-w-full" 
              *ngFor="let hotelName of filteredValues" 
              [checked]="isOptionSelected(hotelName)"
              [disabled]="disabled"
              (change)="selectOption(hotelName)">
              <span class="tw-block tw-truncate tw-max-w-[280px]" [title]="hotelName">{{hotelName}}</span>
            </mat-checkbox>
          </div>
        </div>
      </article>
    </ng-template>
  </div>
</div>
